import React from 'react';
import { Skeleton, SkeletonGroup } from './base/Skeleton';
import { Toolbar } from './Toolbar';

/**
 * โครงหน้าจอระหว่างรอข้อมูลจาก backend — ใช้กับหน้าที่เป็น **ฟอร์ม** ไม่ใช่ตาราง
 *
 * ⚠️ หน้าฟอร์มอย่างระดับสมาชิกกับกติกาคะแนนเคยแสดง**ค่าจำลอง**ระหว่างโหลด
 *    ซึ่งอ่านเหมือนค่าจริง และถ้าเผลอกดบันทึกตอนนั้นจะเขียนทับของจริง
 *    จึงต้องไม่แสดงตัวเลขอะไรเลยจนกว่าข้อมูลจริงจะมาถึง
 *
 * หัวข้อหน้ายังอยู่ เพื่อให้ผู้ใช้รู้ว่าตัวเองอยู่หน้าไหน และหน้าไม่กระโดดตอนข้อมูลมา
 */
export interface ScreenSkeletonProps {
  title: string;
  /** จำนวนบล็อกเนื้อหา — ปรับให้ใกล้เคียงความสูงจริงของหน้านั้น */
  blocks?: number;
}

export const ScreenSkeleton: React.FC<ScreenSkeletonProps> = ({ title, blocks = 3 }) => (
  <div className="flex h-screen min-w-[var(--bo-min-width)] flex-col bg-[var(--surface-100)] font-[family-name:var(--font-thai)]">
    <Toolbar title={title} />
    <div className="min-h-0 flex-1 overflow-auto p-[var(--space-4)]">
      <SkeletonGroup label={`กำลังโหลด${title}`}>
        {Array.from({ length: blocks }, (_, i) => (
          <div
            key={i}
            className="mb-[var(--space-3)] flex flex-col gap-[var(--space-3)] rounded-[var(--radius-lg)] border border-[var(--line-200)] bg-[var(--surface-0)] p-[var(--space-4)]"
          >
            <Skeleton variant="title" width="34%" />
            <Skeleton variant="text" width="88%" />
            <Skeleton variant="text" width="62%" />
          </div>
        ))}
      </SkeletonGroup>
    </div>
  </div>
);

export default ScreenSkeleton;
